/* global $ */

export class Gallery {
	constructor(el, index) {
		this.$body = $('body')
		this.galleryIndex = index
		this.$gallery = $(el)
		this.$galleryLink = this.$gallery.find('.gallery-link a')

		// create overlay and clone gallery to it
		this.createOverlay(this.galleryIndex, this.$gallery)

		// set up anchor clicks on slick init
		this.$gallery.find('.carousel').on('init breakpoint', () => {
			this.$gallery.find('li a').each((index, el) => {
				const $anchor = $(el)
				// launch gallery overlay
				$anchor.off('click').on('click', (e) => {
					e.preventDefault()
					this.showOverlay(this.galleryIndex, $anchor.data('id') - 1)
				})
			})
		})

		// gallery link if it exists
		if (this.$galleryLink) {
			this.$galleryLink.off('click').on('click', (e) => {
				e.preventDefault()
				this.showOverlay(this.galleryIndex, 0)
			})
		}

		// init slick js carousel
		const options = {
			slidesToShow: 2,
			slidesToScroll: 2,
			centerMode: true,
			centerPadding: '288px',
			swipe: false,
			swipeToSlide: false,
			responsive: [
				{
					breakpoint: 1200,
					settings: {
						slidesToShow: 3,
						slidesToScroll: 3,
						centerPadding: '30px',
					},
				},
				{
					breakpoint: 1024,
					settings: {
						slidesToShow: 2,
						slidesToScroll: 2,
						centerPadding: '30px',
					},
				},
				{
					breakpoint: 768,
					settings: {
						slidesToShow: 1,
						slidesToScroll: 1,
						centerPadding: '30px',
					},
				},
			],
		}
		this.$gallery.find('.carousel').slick(options)

		// close button
		this.$body.on('click', '.overlay--gallery .close', (e) => {
			e.preventDefault()
			this.hideOverlays()
		})

		// esc button
		$(window).on('keyup', (e) => {
			if (e.keyCode === 27) {
				this.hideOverlays()
			}
		})
	}

	createOverlay(index) {
		const overLayId = 'gallery-' + index

		// create overlay if it doesn't exist
		if (!$('#' + overLayId).length) {
			$('main').append($('<div class="overlay overlay--gallery" id="' + overLayId + '"><div class="close"><span>Close</span></div></div>'))
		}

		const $overlay = $('#' + overLayId)

		if ($overlay.length) {
			// clone the carousel
			const $clone = this.$gallery.find('.carousel').clone()
			$overlay.append($clone)

			const $carousel = $overlay.find('.carousel')

			// swap out large images, and remove anchors
			$carousel.find('img').each(function () {
				$(this).attr('src', $(this).data('large'))
				$(this).unwrap()
			})

			// init slick js carousel
			const options = { slidesToShow: 1, slidesToScroll: 1 }
			$carousel.slick(options)
		}
	}

	showOverlay(galleryIndex, anchorIndex) {
		const $overlay = $('#gallery-' + galleryIndex)

		if (!$overlay.length) return

		if (!$overlay.hasClass('show')) {
			// jump to corresponding image
			const $carousel = $overlay.find('.carousel')
			$carousel.slick('goTo', anchorIndex, true)

			$overlay.addClass('show')

			// disable body scroll
			this.$body.addClass('no-scroll')
		}
	}

	hideOverlays() {
		// check for orientation change
		const event = new CustomEvent('check-orientation-refresh', {
			bubbles: true,
			detail: { forced: true }
		})
		document.dispatchEvent(event)

		$('.overlay--gallery').each((index, el) => {
			if ($(el).hasClass('show')) {
				const $overlay = $(el)

				$overlay.one('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend', () => {
					$overlay.off('webkitTransitionEnd otransitionend oTransitionEnd msTransitionEnd transitionend')
					$overlay.removeClass('show hide')
				})

				$overlay.addClass('hide')

				// enable body scroll
				this.$body.removeClass('no-scroll')
			}
		})
	}
}
